import React from "react";

function NotificationListEmpty() {
  return (
    <div className="p-0">
      <ul className="list-group list-group-flush">
        <li className="list-group-item d-flex rounded-3 flex-column align-items-center justify-content-center py-5 text-center">
          <div
            className="rounded-circle bg-primary bg-opacity-10 text-primary d-flex align-items-center justify-content-center mb-3"
            style={{ width: "56px", height: "56px" }}
          >
            <i className="bi bi-bell-slash fs-4" />
          </div>
          <p className="mb-1 fw-semibold small">No notifications</p>
          <p className="mb-0 text-muted" style={{ fontSize: "12px" }}>
            You're all caught up! Check back later.
          </p>
        </li>
      </ul>
    </div>
  );
}

export default NotificationListEmpty;
